<template>
  <div class="relative flex flex-col h-min-[264px] bg-complementary-900 rounded-md px-6 py-4">
    <div class="flex flex-row mb-[8px]">
      <span class="material-symbols-rounded text-complementary-300">live_help</span>
      <p class="text-lg font-bold mr-[7px] text-complementary-300">{{ fact.title }}</p>
    </div>
    <p class="text-white text-base font-regular text-right">{{ fact.description }}</p>
  </div>
</template>

<script>
export default {
  name: "faq-fact",
  props: {
    fact: {
      type: Object,
      required: true,
    }
  }
}
</script>

<style>

</style>